export default {
    title: "Kevi | Estado del pedido",
    page_title: "Estado de pedido",
    approved: "Aprobado",
    pending: "Pendiente",
    cancelled: "Cancelado",
    save: "Guardar",
    success_message: "Estados actualizados",
    external_label_column: "Estado externo",
    kevi_status_column: "Estado Kevi",
    repurchase_reference_column: "Referencia de recompra",
    repurchase_reference_help:
        "La referencia de recompra define desde cuándo empieza a contar el tiempo de recompra de los productos. Sin ningún estado marcado, el conteo comienza en la fecha de creación del pedido. Al marcar uno o más estados, un pedido aprobado solo empieza a contar cuando alcanza el primer estado marcado (por ejemplo, \"entregado\"), usando el momento en que Kevi detectó ese cambio. Cambiar esta selección recalcula las previsiones en la próxima ejecución nocturna.",
};
